import { getBaseColumns, applyReferenceLayout } from "../../utils/sharedTableColumns";

export const orderColumns = ({
  openReportEditor, // Opens report editor in new tab (for both patient name and action icon)
}) => {
  const baseColumns = getBaseColumns();

  // Customize patient name column to open report editor in new tab
  const patientNameColumn = baseColumns.find(col => col.key === 'pat_name');
  if (patientNameColumn) {
    const originalRender = patientNameColumn.render;
    patientNameColumn.render = (text, record) => originalRender(text, record, openReportEditor);
  }

  // Reference RIS-style flex layout (fit-to-viewport, no horizontal scroll). The
  // action icons live in a leading (left-pinned) cluster built by the page via
  // buildLeadingActionColumns - they are no longer a trailing Actions column.
  return applyReferenceLayout(baseColumns);
};
